import HrEmployeesPage from './HrEmployeesPage';

export default HrEmployeesPage;